"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "META_DEPENDENCY_MODULE_PROVIDER_KEY", {
    enumerable: true,
    get: function() {
        return META_DEPENDENCY_MODULE_PROVIDER_KEY;
    }
});
const META_DEPENDENCY_MODULE_PROVIDER_KEY = 'META_DEPENDENCY';
